/**
 * Sort menu sections, categories, and items by position so the order
 * from the Categories/Dishes management (reorder, drag & drop) is reflected
 * on public menu pages. Safe to use for any menu payload from the API.
 */
export function sortMenuByPosition<T extends Record<string, unknown>>(menu: T | null): T | null {
  if (!menu) return menu;

  const sections = (menu.MenuSections as Array<{ position?: number; Categories?: Array<{ position?: number; MenuItems?: unknown[]; items?: unknown[] }> }> | undefined) ?? [];
  const sortedSections = sections.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

  sortedSections.forEach((section) => {
    if (section.Categories) {
      section.Categories = section.Categories.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
      section.Categories.forEach((cat) => {
        if (cat.MenuItems) {
          (cat as { MenuItems: Array<{ position?: number }> }).MenuItems = (cat.MenuItems as Array<{ position?: number }>).slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
        }
        if (cat.items) {
          (cat as { items: Array<{ position?: number }> }).items = (cat.items as Array<{ position?: number }>).slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
        }
      });
    }
  });

  let sortedCategories = (menu.categories as Array<{ position?: number }> | undefined);
  if (sortedCategories && sortedCategories.length > 0) {
    sortedCategories = sortedCategories.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  }

  return {
    ...menu,
    MenuSections: sortedSections,
    ...(sortedCategories ? { categories: sortedCategories } : {}),
  } as T;
}
